function moveBarToBodyOnMobile() {
  const addToCartWrapperElement = document.querySelector(".act-wrapper");
  const container = document.querySelector(".act-wrapper-main-wrapper");
  if (!addToCartWrapperElement || !container) return;
  if (window.innerWidth <= 768 && addToCartWrapperElement.parentNode !== document.body) {
    document.body.appendChild(addToCartWrapperElement);
    if (container) container.style.display = "none"; // Hide empty wrapper
  } else if (window.innerWidth > 768 && addToCartWrapperElement.parentNode === document.body) {
    if (container) {
      container.appendChild(addToCartWrapperElement);
      container.style.display = ""; // Restore wrapper display
    }
  }
}

document.addEventListener("DOMContentLoaded", moveBarToBodyOnMobile);
window.addEventListener("resize", moveBarToBodyOnMobile);
window.addEventListener("orientationchange", moveBarToBodyOnMobile);
window.addEventListener("load", moveBarToBodyOnMobile);
